<div class="toggle-wrapper" [class.disabled]="disabled">
    <div class="toggle-container" (click)="toggle()">
      <div class="toggle-switch" [class.active]="value">
        <div class="toggle-ball"></div>
      </div>
    </div>
  </div>
  